import SheetProps from './SheetProps'

export default {
    name: 'kendo-spreadsheet-sheet',
    render () {
        return null
    },
    mixins: [SheetProps]
}


// WEBPACK FOOTER //
// ./packages/kendo-spreadsheet-vue-wrapper/src/KendoSpreadsheetSheet/index.js